import React from "react";
import { useLocation } from "react-router-dom";
const Head = ({ setPostPerPage, setQuery }) => {
  const locations = useLocation();
  const path = locations.pathname;
  const page = path === "/media" ? false : true;

  return (
    <div className="container-page-top">
      <select
        class="custom-select rounded"
        onChange={(e) => setPostPerPage(e.target.value)}
      >
        <option selected value="10">
          10 / pages
        </option>
        <option value="20">20 / pages</option>
        <option value="30">30 / pages</option>
        <option value="40">40 / pages</option>
      </select>
      {page && (
        <div className="search-input">
          <div class="search-box">
            <input
              placeholder="Search..."
              onChange={(event) => setQuery(event.target.value)}
            />
            <i className="fas fa-search icon me-1"></i>
          </div>
        </div>
      )}
    </div>
  );
};

export default Head;
